import { render, staticRenderFns } from "./IntelligenceProviderPerformanceKpiCards.vue?vue&type=template&id=04113a64&scoped=true"
import script from "./IntelligenceProviderPerformanceKpiCards.vue?vue&type=script&lang=js"
export * from "./IntelligenceProviderPerformanceKpiCards.vue?vue&type=script&lang=js"
import style0 from "./IntelligenceProviderPerformanceKpiCards.vue?vue&type=style&index=0&id=04113a64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04113a64",
  null
  
)

export default component.exports